module.exports = __webpack_public_path__ + "img/der-tagesspiegel.f874e51d.png";